import { render, staticRenderFns } from "./ShiftBadge.vue?vue&type=template&id=18099bbc&scoped=true"
import script from "./ShiftBadge.vue?vue&type=script&lang=js"
export * from "./ShiftBadge.vue?vue&type=script&lang=js"
import style0 from "./ShiftBadge.vue?vue&type=style&index=0&id=18099bbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18099bbc",
  null
  
)

export default component.exports